import { FormPagePropertyItem } from 'backend';
import { FormPageInputData, PROPERTY_TYPE } from 'shared';
import { PropertyItemElement } from '../getPropertyItemElements';
import { getDateInputValue } from './date';
import { getMailddressInputValue } from './mailAddress';
import { getMailRefusalFlagInputValue } from './mailRefusalFlag';
import { getMonthDayInputValue } from './monthDay';
import { getMultipleSelectionInputValue } from './multipleSelection';
import { getNumberInputValue } from './number';
import { getPasswordHashInputValue } from './passwordHash';
import { getSingleSelectionInputValue } from './singleSelection';
import { getTextInputValue } from './text';

export const getInputValue = (
  propertyItem: FormPagePropertyItem,
  propertyItemElement: PropertyItemElement,
  isFormCustomize: boolean,
): FormPageInputData => {
  switch (propertyItem.propertyType) {
    case PROPERTY_TYPE.mailAddress: {
      return getMailddressInputValue(propertyItem, propertyItemElement);
    }
    case PROPERTY_TYPE.text: {
      return getTextInputValue(propertyItem, propertyItemElement);
    }
    case PROPERTY_TYPE.number: {
      return getNumberInputValue(propertyItem, propertyItemElement);
    }
    case PROPERTY_TYPE.date: {
      return getDateInputValue(propertyItem, propertyItemElement);
    }
    case PROPERTY_TYPE.monthDay: {
      return getMonthDayInputValue(propertyItem, propertyItemElement);
    }
    case PROPERTY_TYPE.singleSelection: {
      return getSingleSelectionInputValue(
        propertyItem,
        propertyItemElement,
        isFormCustomize,
      );
    }
    case PROPERTY_TYPE.multipleSelection: {
      return getMultipleSelectionInputValue(
        propertyItem,
        propertyItemElement,
        isFormCustomize,
      );
    }
    case PROPERTY_TYPE.passwordHash: {
      return getPasswordHashInputValue(propertyItem, propertyItemElement);
    }
    case PROPERTY_TYPE.mailRefusalFlag: {
      return getMailRefusalFlagInputValue(propertyItem, propertyItemElement);
    }
    default: {
      return {};
    }
  }
};
